module.exports = __webpack_public_path__ + "img/CY120013.ae5703fc.png";